export const LAUNCHPAD = 'launchpad';
export const BLOCSWAVE = 'blocswave';
export const GROOVEBOX = 'groovebox';

export const BUILD_ENV_PROD = 'production';
export const BUILD_ENV_DEV = 'develop';
